"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unpairTerminal = exports.updateTerminalInfo = exports.getTerminals = exports.getTerminal = exports.asyncPairTerminal = exports.getConnectionStatus = void 0;
const shared_1 = require("@getgreenline/shared");
const setBaseUrl = ({ tenantId, retailerId }) => {
    return `${shared_1.WORLDPAY_API_URL}/worldpay/tenants/${tenantId}/retailers/${retailerId}/connections`;
};
const getConnectionStatus = async (params) => {
    const { connectionId, ...restOfParams } = params;
    const apiUrl = `${setBaseUrl(restOfParams)}/${connectionId}/status`;
    const res = await shared_1.axios.get(apiUrl);
    return res.data;
};
exports.getConnectionStatus = getConnectionStatus;
const asyncPairTerminal = async (params) => {
    const { payload, ...restOfParams } = params;
    const apiUrl = setBaseUrl(restOfParams);
    const res = await shared_1.axios.post(apiUrl, payload);
    return res.data;
};
exports.asyncPairTerminal = asyncPairTerminal;
const getTerminal = async (params) => {
    const { connectionId, ...restOfParams } = params;
    const apiUrl = `${setBaseUrl(restOfParams)}/${connectionId}`;
    const res = await shared_1.axios.get(apiUrl);
    const statusCode = res.status;
    return { statusCode, ...res.data };
};
exports.getTerminal = getTerminal;
const getTerminals = async (params) => {
    const apiUrl = setBaseUrl(params);
    const res = await shared_1.axios.get(apiUrl);
    return res.data;
};
exports.getTerminals = getTerminals;
const updateTerminalInfo = async (params) => {
    const { connectionId, payload, ...restOfParams } = params;
    const apiUrl = `${setBaseUrl(restOfParams)}/${connectionId}`;
    const res = await shared_1.axios.patch(apiUrl, payload);
    return res.data;
};
exports.updateTerminalInfo = updateTerminalInfo;
const unpairTerminal = async (params) => {
    const { connectionId, ...restOfParams } = params;
    const apiUrl = `${setBaseUrl(restOfParams)}/${connectionId}`;
    const res = await shared_1.axios.delete(apiUrl);
    return res.data;
};
exports.unpairTerminal = unpairTerminal;
//# sourceMappingURL=WorldpayTerminalAPI.js.map